module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.onResize),
      expression: "onResize"
    }],
    style: ({
      'width': (_vm.width + "px")
    })
  }, [_c('v-layout', {
    staticClass: "info-bg light-blue darken-2",
    attrs: {
      "justify-center": ""
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "info-profile-img",
    attrs: {
      "justify-center": ""
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "150px"
    },
    attrs: {
      "src": _vm.user.avatar
    }
  })]), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-5",
    attrs: {
      "justify-center": ""
    }
  }, [_vm._v("\n    " + _vm._s(_vm.user.firstname) + " " + _vm._s(_vm.user.lastname) + "\n  ")]), _vm._v(" "), _c('v-layout', {
    staticClass: "px-3"
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "pl-0 pt-0 info-list"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.title,
      staticClass: "px-0"
    }, [(item.icon) ? _c('v-icon', {
      staticClass: "mr-1"
    }, [_vm._v(_vm._s(item.icon))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pt-1"
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f6dfbef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/grouppage/UserInfo.vue
// module id = 1681
// module chunks = 17